import { Amenity } from '@shared/models/amenity.model';
import { FlightSearchResponseAirline } from '@shared/models/flight-search-response.model';
import { IFilterTags } from '@shared/models/tag';
import * as filterActions from '../actions/filter.actions';

export interface FilterState {
  dining: {
    cuisine: Amenity[];
    tag: Amenity[];
    esg_tag: Amenity[];
    memberBenefits: Amenity[];
  };
  memberEvents: {
    tag: Array<any>;
  };
  entertainment: {
    category: Array<any>;
  };
  memberBenefits: {
    tag: Array<IFilterTags>;
  };
  memberBenefitsSearch: {
    tag: Array<IFilterTags>;
  };
  hotels: {
    amenity: Array<Amenity>;
    property_class: Array<any>;
  };
  flights: {
    airline: Array<FlightSearchResponseAirline>;
    departure_time: Array<FlightSearchResponseAirline>;
    return_time: Array<FlightSearchResponseAirline>;
  };
  cars: {
    supplier: Array<any>;
    pax_capacity: Array<any>;
    car_type: Array<any>;
    instalment_payment_available: boolean;
  };
  articles: {
    category: Array<any>;
  };
  inspiration: {
    category: Array<any>;
    destination: Array<any>;
  };
  preferences: {
    entertainments_only: boolean;
    brands_only: boolean;
  };
  primaryInterest: {
    category: Array<any>;
  };
}

export const initialState: FilterState = {
  dining: {
    cuisine: [],
    tag: [],
    memberBenefits: [],
    esg_tag: [],
  },
  memberEvents: {
    tag: [],
  },
  entertainment: {
    category: [],
  },
  memberBenefits: {
    tag: [],
  },
  memberBenefitsSearch: {
    tag: [],
  },
  hotels: {
    amenity: [],
    property_class: [],
  },
  flights: {
    airline: [],
    departure_time: [],
    return_time: [],
  },
  cars: {
    supplier: [],
    pax_capacity: [],
    car_type: [],
    instalment_payment_available: false,
  },
  articles: {
    category: [],
  },
  inspiration: {
    category: [],
    destination: [],
  },
  preferences: {
    entertainments_only: false,
    brands_only: false,
  },
  primaryInterest: {
    category: [],
  },
};

const sortByName = (sortable: IFilterTags[]) => {
  return sortable.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
};

export function reducer(state: FilterState = initialState, action: filterActions.FiltersAction): FilterState {
  switch (action.type) {
    case filterActions.GET_DINING_FILTERS_SUCCESS: {
      return {
        ...state,
        dining: {
          cuisine: [...action.payload.cuisines],
          tag: [...action.payload.tags],
          memberBenefits: [...action.payload.memberBenefits],
          esg_tag: [...action.payload.esg_tags],
        },
      };
    }
    case filterActions.GET_STATE_DINING_FILTERS: {
      return state;
    }
    case filterActions.GET_MEMBER_EVENT_FILTERS_SUCCESS: {
      return {
        ...state,
        memberEvents: {
          tag: [...action.payload],
        },
      };
    }
    case filterActions.GET_ENTERTAINMENT_FILTERS_SUCCESS: {
      return {
        ...state,
        entertainment: {
          category: [...action.payload],
        },
      };
    }
    case filterActions.GET_MEMBER_BENEFITS_FILTERS_SUCCESS: {
      return {
        ...state,
        memberBenefits: {
          tag: [...action.payload],
        },
      };
    }
    case filterActions.GET_HOTEL_FILTERS_SUCCESS: {
      return {
        ...state,
        hotels: {
          amenity: [...action.payload.amenities],
          property_class: [...action.payload.starRatings],
        },
      };
    }
    case filterActions.GET_FLIGHT_FILTERS_SUCCESS: {
      return {
        ...state,
        flights: {
          departure_time: action.payload.departure,
          return_time: action.payload.return,
          airline: action.payload.airlines,
        },
      };
    }
    case filterActions.GET_CAR_FILTERS_SUCCESS: {
      return {
        ...state,
        cars: {
          pax_capacity: action.payload.pax_capacity,
          supplier: action.payload.supplier,
          car_type: action.payload.car_type,
          instalment_payment_available: action.payload.instalment_payment_available,
        },
      };
    }
    case filterActions.GET_ARTICLE_FILTERS_SUCCESS: {
      const tags = sortByName([...action.payload]);

      return {
        ...state,
        articles: {
          category: tags,
        },
      };
    }
    case filterActions.GET_INSPIRATION_FILTERS_SUCCESS: {
      const categories = [...action.payload.category];
      const destinations = [...action.payload.destination];

      return {
        ...state,
        inspiration: {
          destination: destinations,
          category: categories,
        },
      };
    }
    case filterActions.GET_PREFERENCES_FILTERS_SUCCESS: {
      return {
        ...state,
        primaryInterest: {
          category: [...action.payload],
        },
      };
    }
    default:
      return state;
  }
}
